import { ChannelTypeEnum } from "../types";
import {
  WHATSAPP_ACCOUNT_WS_ADDRESS,
  WHATSAPP_CHAT_WS_ADDRESS,
  WHATSAPP_CONTACT_WS_ADDRESS,
} from "../constants";
import { wsHandler } from "../handler/whatsapp/ws-handler";
import chatSdkHooks from "../hooks";
import { WebSocketClient } from "./ws";

export const whatsappAccountWsClient = new WebSocketClient({
  wsAddress: WHATSAPP_ACCOUNT_WS_ADDRESS,
  onConnectStatusChange: (status) =>
    chatSdkHooks.common.wsConnectStatusChangeHook.emit({
      channelType: ChannelTypeEnum.WhatsApp,
      status,
    }),
  onMessage: wsHandler,
  onSendMessageError: (data) => chatSdkHooks.common.sendMessageError.emit(data),
  onError: (data) =>
    chatSdkHooks.common.wsErrorHook.emit({
      channelType: ChannelTypeEnum.WhatsApp,
      ...data,
    }),
  onAutoReconnectionFailed: (path, connectParams) => {
    chatSdkHooks.common.autoReconnectionFailedHook.emit({
      path,
      connectParams,
    });
  },
});

export const whatsappChatWsClient = new WebSocketClient({
  wsAddress: WHATSAPP_CHAT_WS_ADDRESS,
  onConnectStatusChange: (status) =>
    chatSdkHooks.common.wsConnectStatusChangeHook.emit({
      channelType: ChannelTypeEnum.WhatsApp,
      status,
    }),
  onMessage: wsHandler,
  onSendMessageError: (data) => chatSdkHooks.common.sendMessageError.emit(data),
  onError: (data) =>
    chatSdkHooks.common.wsErrorHook.emit({
      channelType: ChannelTypeEnum.WhatsApp,
      ...data,
    }),
  onAutoReconnectionFailed: (path, connectParams) => {
    chatSdkHooks.common.autoReconnectionFailedHook.emit({
      path,
      connectParams,
    });
  },
});

export const whatsappContactWsClient = new WebSocketClient({
  wsAddress: WHATSAPP_CONTACT_WS_ADDRESS,
  onConnectStatusChange: (status) =>
    chatSdkHooks.common.wsConnectStatusChangeHook.emit({
      channelType: ChannelTypeEnum.WhatsApp,
      status,
    }),
  onMessage: wsHandler,
  onSendMessageError: (data) => chatSdkHooks.common.sendMessageError.emit(data),
  onError: (data) =>
    chatSdkHooks.common.wsErrorHook.emit({
      channelType: ChannelTypeEnum.WhatsApp,
      ...data,
    }),
  onAutoReconnectionFailed: (path, connectParams) => {
    chatSdkHooks.common.autoReconnectionFailedHook.emit({
      path,
      connectParams,
    });
  },
});
